import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { useAuthentication } from '../../LoginPage';
import React, { useState, useEffect } from 'react';
import { NumericFormat } from 'react-number-format';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { BusinessAndPeopleApi } from '@apply/api';
import { BooleanTypeOptions } from '../constants/BooleanTypeOptions';
import ButtonGroup from 'devextreme-react/button-group';
import { FileUploader } from 'devextreme-react';
import MaskedInput from 'react-text-mask';
import { stateSelectorValues, alertModal, countyList } from '@apply/ui';

interface IEditGeneralContractorModal {
    isOpen: boolean;
    onCloseCallback?: () => void;
    applicationInsights: ApplicationInsights;
    selectedBusinessId: number;
    generalContractorId: number;
}
export const EditGeneralContractorModal: React.FC<IEditGeneralContractorModal> = (props) => {
    const businessAndPeopleApi = new BusinessAndPeopleApi.BusinessAndPeopleApi(props.applicationInsights);

    const { authentication, isFeatureEnabled } = useAuthentication();
    const [validation, set_validation] = useState(undefined);
    const [loadingMessage, set_loadingMessage] = useState('');
    const [loadingOpen, set_loadingOpen] = useState(false);
    const [saveEnabled, set_saveEnabled] = useState(false);
    const [mailingAddressCountySelectList, set_MailingAddressCountySelectList] = useState<{ value: string; display: string }[]>(
        []
    );

    const [generalContractor, set_generalContractor] = useState(null);
    const [canContinue, set_canContinue] = useState(true);

    const [businessId, set_businessId] = useState(0);

    const [licensedState, set_licensedState] = useState<string>('');
    const [businessName, set_businessName] = useState<string>('');
    const [firstName, set_firstName] = useState<string>('');
    const [lastName, set_lastName] = useState<string>('');
    const [licenseNumber, set_licenseNumber] = useState<string>('');
    const [licenseEverRevoked, set_licenseEverRevoked] = useState<typeof BooleanTypeOptions>([]);
    const [phoneNumber, set_phoneNumber] = useState<string>('');
    const [email, set_email] = useState<string>('');
    const [street1, set_street1] = useState<string>('');
    const [street2, set_street2] = useState<string>('');
    const [city, set_city] = useState<string>('');
    const [state, set_state] = useState<string>('');
    const [zipCode, set_zipcode] = useState<string>('');
    const [county, set_county] = useState<string>('');
    const [resumeFile, set_resumeFile] = useState(null);
    const [resumeText, set_resumeText] = useState<string>('');

    const maxFileSize = 1024 * 1024 * 35;

    useEffect(() => {
        set_businessId(props.selectedBusinessId);
    }, [props.selectedBusinessId]);

    const loadDetails = async (id: number) => {
        // set_loadingMessage("Loading...");
        // set_loadingOpen(true);
        // const response = await businessAndPeopleApi.getGeneralContractor(id);
        // if (!response || response.statusCode !== 200) {
        //   return;
        // }
        // set_generalContractor(response.result);
    };

    useEffect(() => {
        async function generalContractorIdChanged() {
            resetState();
            if (!props.generalContractorId || props.generalContractorId <= 0) {
                set_generalContractor(null);
                return;
            }

            await loadDetails(props.generalContractorId);
            set_loadingOpen(false);
        }

        generalContractorIdChanged();
    }, [props.generalContractorId]);

    useEffect(() => {
        setState(generalContractor);
    }, [generalContractor]);

    useEffect(() => {
        let fieldsValid = false;

        fieldsValid =
            firstName !== '' &&
            lastName !== '' &&
            licenseNumber !== '' &&
            licenseEverRevoked.length !== 1 &&
            phoneNumber.length !== 10 &&
            email !== '' &&
            street1 !== '' &&
            city !== '' &&
            state !== '' &&
            zipCode !== '' &&
            (resumeFile !== null || resumeText !== '');

        set_canContinue(fieldsValid);
    }, [firstName, lastName, licenseNumber, phoneNumber, email, licenseEverRevoked]);

    const setState = (generalContractor: any) => {
        if (!generalContractor) {
            return;
        }
        set_licensedState(generalContractor.licensedState);
        set_firstName(generalContractor.firstName);
        set_lastName(generalContractor.lastName);
        set_licenseNumber(generalContractor.licenseNumber);
        set_licenseEverRevoked(generalContractor.licenseEverRevoked);
        set_phoneNumber(generalContractor.phoneNumber);
        set_email(generalContractor.email);
        set_street1(generalContractor.street1);
        set_street2(generalContractor.street2);
        set_city(generalContractor.city);
        set_state(generalContractor.state);
        set_zipcode(generalContractor.zipCode);
        set_county(generalContractor.county);
        set_resumeFile(generalContractor.resumeFile);
        set_resumeText(generalContractor.resumeText);
    };

    const resetState = () => {
        set_generalContractor(null);
        set_businessId(0);
        set_licensedState('');
        set_firstName('');
        set_lastName('');
        set_licenseNumber('');
        set_licenseEverRevoked([]);
        set_phoneNumber('');
        set_email('');
        set_street1('');
        set_street2('');
        set_city('');
        set_state('');
        set_zipcode('');
        set_county('');
        set_resumeFile(null);
        set_resumeText('');
    };

    const getSuccessMessage = (id: number) => {
        if (id === 0) {
            return 'Your General Contractor was added successfully.';
        } else {
            return 'Your General Contractor was updated successfully';
        }
    };

    const getGeneralErrorMessage = () => {
        return 'An error has occurred while communicating with our server.  Please try your operation again.';
    };

    const onFileChanged = (fileArray: any) => {
        const files = fileArray.filter((file: any) => file.size <= maxFileSize);
        if (files && files.length > 0) {
            set_canContinue(true);
        } else {
            set_canContinue(false);
        }
        set_resumeFile(files[0]);
    };

    const handleClose = () => {
        set_generalContractor(null);
        set_validation(undefined);
        resetState();
        props.onCloseCallback(null);
    };

    const cancelGeneralContractor = () => {
        set_generalContractor(null);
        set_validation(undefined);
        resetState();
        props.onCloseCallback(null);
    };

    useEffect(() => {
        const tempCountyList = countyList
            .filter((county) => county.state === state)
            .map((county) => {
                return { display: county.county, value: county.county };
            });
        tempCountyList.unshift({ display: '', value: '' });
        set_MailingAddressCountySelectList(tempCountyList);
    }, [state]);

    const validateGeneralContractor = async () => {
        // //Check should validate whether the name already exists (general contractor) already exists in the system / business - confirm requirements
        // set_loadingMessage("Validating...");
        // set_loadingOpen(true);
        // set_validation(undefined);
        // try {
        //   const model = {
        //     businessId,
        //     firstName,
        //     lastName,
        //   };
        //   const response = await businessAndPeopleApi.validateGeneralContractor(model);
        //   if (response.statusCode !== 200 || !response.result) {
        //     set_loadingOpen(false);
        //     return false;
        //   }
        //   if (response.result.hasErrors || response.result.hasWarnings) {
        //     set_validation(response.result);
        //     set_loadingOpen(false);
        //     return false;
        //   }
        //   return true;
        // } catch (ex) {
        //   set_loadingOpen(false);
        //   set_validation(undefined);
        //   alertModal({
        //     message:
        //       getGeneralErrorMessage(),
        //   });
        //   return false;
        // }
    };

    const saveGeneralContractor = async () => {
        // try {
        //     const isValid = await validateGeneralContractor();
        //     if (!isValid) {
        //         return;
        //     }
        //     const model = {
        //         generalContractorId: props.generalContractorId,
        //         businessId: props.selectedBusinessId ?? 0,
        //         licensedState,
        //         firstName,
        //         lastName,
        //         licenseNumber,
        //         licenseEverRevoked: licenseEverRevoked[0].id,
        //         phoneNumber,
        //         email,
        //         street1,
        //         street2,
        //         city,
        //         state,
        //         zipCode,
        //         county,
        //         resumeFile,
        //         resumeText,
        //     };
        //     const response = await businessAndPeopleApi.saveGeneralContractor(model);
        //     if (response.statusCode !== 200 || !response.result) {
        //         set_loadingOpen(false);
        //         alert(response.errors[0]);
        //         return false;
        //     }
        //     set_loadingOpen(false);
        //     alertModal({
        //         title: 'Success',
        //         message: getSuccessMessage(model.generalContractorId),
        //         onConfirm: () => {
        //             handleClose();
        //         },
        //     });
        // } catch (ex) {
        //     set_loadingOpen(false);
        //     set_validation(undefined);
        //     alertModal({
        //         message: getGeneralErrorMessage(),
        //     });
        //     return false;
        // }
    };

    return (
        <div>
            <Dialog
                open={props.isOpen}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                maxWidth='md'
            >
                <DialogContent>
                    <div className='modal-container'>
                        <div className='modal-backdrop'></div>
                        <div
                            className='modal'
                            role='dialog'
                            style={{ width: '650px', maxWidth: '80vw' }}
                        >
                            <div
                                className='modal-dialog'
                                role='document'
                            >
                                <div
                                    className='page-header'
                                    role='banner'
                                >
                                    <h1>
                                        {!props.generalContractorId && props.generalContractorId === 0
                                            ? 'Add General Contractor'
                                            : 'Edit General Contractor'}
                                    </h1>
                                    <button
                                        type='button'
                                        className='close'
                                        data-dismiss='modal'
                                        aria-label='Close'
                                        onClick={handleClose}
                                    >
                                        <span aria-hidden='true'>&times;</span>
                                    </button>
                                </div>
                                <div className='modal-content'>
                                    <div className='modal-body'>
                                        <div
                                            className='standard-form'
                                            style={{
                                                padding: 0,
                                            }}
                                        >
                                            <div
                                                className='scrollable-content'
                                                style={{ margin: '10px' }}
                                            >
                                                <div className='row'>
                                                    <div className='businessandpeople-modal-subheader'>
                                                        Contractor Information
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='businessName'>Business Name</label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>The name of the Contractor's business.</span>
                                                        </span>
                                                        <input
                                                            type='text'
                                                            id='businessName'
                                                            value={businessName}
                                                            onChange={(e) => set_businessName(e.target.value)}
                                                            maxLength={50}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-6'>
                                                        <label htmlFor='firstName'>
                                                            First Name
                                                            <span className='req'>*</span>
                                                        </label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>The Contractor's first name.</span>
                                                        </span>
                                                        <input
                                                            type='text'
                                                            id='firstName'
                                                            value={firstName}
                                                            onChange={(e) => set_firstName(e.target.value)}
                                                            required={true}
                                                            maxLength={50}
                                                        />
                                                    </div>
                                                    <div className='columns small-12 large-6'>
                                                        <label htmlFor='lastName'>
                                                            Last Name
                                                            <span className='req'>*</span>
                                                        </label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>The Contractor's last name.</span>
                                                        </span>
                                                        <input
                                                            type='text'
                                                            id='lastName'
                                                            value={lastName}
                                                            onChange={(e) => set_lastName(e.target.value)}
                                                            required={true}
                                                            maxLength={50}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-6'>
                                                        <label htmlFor='licenseState'>
                                                            License State<span className='req'>*</span>
                                                        </label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>
                                                                State in which the Contractor's License was issued.
                                                            </span>
                                                        </span>
                                                        <select
                                                            id={'licenseState'}
                                                            value={licensedState ?? ''}
                                                            required={true}
                                                            onChange={(event) => set_licensedState(event.target.value)}
                                                        >
                                                            {stateSelectorValues.map((v, i) => {
                                                                return (
                                                                    <option
                                                                        key={i}
                                                                        value={v.value}
                                                                    >
                                                                        {v.display}
                                                                    </option>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                    <div className='columns small-12 large-6'>
                                                        <label htmlFor='licenseNumber'>
                                                            License Number<span className='req'>*</span>
                                                        </label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>Contractor's builder's license number</span>
                                                        </span>
                                                        <input
                                                            id='licenseNumber'
                                                            type='text'
                                                            required={true}
                                                            value={licenseNumber}
                                                            onChange={(event) => set_licenseNumber(event.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='licenseEverRevoked'>
                                                            Has this license ever been revoked?
                                                            <span className='req'>*</span>
                                                        </label>
                                                        <ButtonGroup
                                                            id='licenseEverRevoked'
                                                            items={BooleanTypeOptions}
                                                            stylingMode='outlined'
                                                            selectionMode='single'
                                                            selectedItems={licenseEverRevoked}
                                                            onSelectedItemsChange={(e) => set_licenseEverRevoked(e)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-6'>
                                                        <label htmlFor='phoneNumber'>
                                                            Phone Number<span className='req'>*</span>
                                                        </label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>
                                                                10 digit phone number, including area code, without symbols e.g.
                                                                5551234567.
                                                            </span>
                                                        </span>
                                                        <span>
                                                            <NumericFormat
                                                                format='(###) ###-####'
                                                                mask='_'
                                                                placeholder='(212) 555-1212'
                                                                name='phoneNumber'
                                                                value={phoneNumber}
                                                                onValueChange={(values) => {
                                                                    set_phoneNumber(values.value);
                                                                }}
                                                                required={true}
                                                            />
                                                        </span>
                                                    </div>
                                                    <div className='columns small-12 large-6'>
                                                        <label htmlFor='email'>
                                                            Email<span className='req'>*</span>
                                                        </label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>
                                                                The email address. i.e. johnsmith@email.com
                                                            </span>
                                                        </span>
                                                        <input
                                                            type='email'
                                                            id='email'
                                                            value={email}
                                                            onChange={(e) => set_email(e.target.value)}
                                                            required={true}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='businessandpeople-modal-subheader'>Business Address</div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='street1'>
                                                            Street Address
                                                            <span className='req'>*</span>
                                                        </label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>
                                                                The street address of the Contractor's business.
                                                            </span>
                                                        </span>
                                                        <input
                                                            id='street1'
                                                            type='text'
                                                            placeholder='123 Main Street'
                                                            maxLength={100}
                                                            value={street1}
                                                            onChange={(event) => set_street1(event.target.value)}
                                                            required={true}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <input
                                                            id='street2'
                                                            type='text'
                                                            placeholder='Suite 123'
                                                            maxLength={100}
                                                            value={street2}
                                                            onChange={(event) => set_street2(event.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-7'>
                                                        <label htmlFor='city'>
                                                            City <span className='req'>*</span>
                                                        </label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>The city of the Contractor's business.</span>
                                                        </span>
                                                        <input
                                                            id='city'
                                                            type='text'
                                                            maxLength={100}
                                                            placeholder='Hamilton'
                                                            value={city}
                                                            onChange={(event) => set_city(event.target.value)}
                                                            required={true}
                                                        />
                                                    </div>
                                                    <div className='columns small-12 large-5'>
                                                        <label htmlFor='state'>
                                                            State <span className='req'>*</span>
                                                        </label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>The state of the Contractor's business.</span>
                                                        </span>
                                                        <select
                                                            id={'state'}
                                                            value={state ?? ''}
                                                            onChange={(event) => set_state(event.target.value)}
                                                            required={true}
                                                        >
                                                            {stateSelectorValues.map((v, i) => {
                                                                return (
                                                                    <option
                                                                        key={i}
                                                                        value={v.value}
                                                                    >
                                                                        {v.display}
                                                                    </option>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-4'>
                                                        <label htmlFor='zipCode'>
                                                            Zip Code <span className='req'>*</span>
                                                        </label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>
                                                                The zip code of the Contractor's business.
                                                            </span>
                                                        </span>
                                                        <MaskedInput
                                                            id='zipCode'
                                                            mask={[/\d/, /\d/, /\d/, /\d/, /\d/]}
                                                            guide={true}
                                                            type='text'
                                                            placeholder='12345'
                                                            value={zipCode}
                                                            onChange={(event: any) => set_zipcode(event.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                    <div className='columns small-12 large-5'>
                                                        <label htmlFor={'county'}>County</label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>The county of the Contractor's business.</span>
                                                        </span>
                                                        <select
                                                            id={'county'}
                                                            value={county ?? ''}
                                                            onChange={(event) => set_county(event.target.value)}
                                                        >
                                                            {mailingAddressCountySelectList.map((v, i) => {
                                                                return (
                                                                    <option
                                                                        key={i}
                                                                        value={v.value}
                                                                    >
                                                                        {v.display}
                                                                    </option>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='businessandpeople-modal-subheader'>Resume</div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='resumeFile'>General Contractor's Resume (Upload)</label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>Upload the General Contractor's Resume.</span>
                                                        </span>
                                                        <div style={{ border: '1px solid lightgray' }}>
                                                            <FileUploader
                                                                id='resumeFile'
                                                                selectButtonText='Select Files'
                                                                uploadMode='useForm'
                                                                maxFileSize={maxFileSize}
                                                                invalidFileExtensionMessage='Invalid File Type. File will be ignored'
                                                                invalidMaxFileSizeMessage='File too large. File will be ignored'
                                                                multiple={false}
                                                                allowedFileExtensions={['.pdf', '.png', '.jpg']}
                                                                allowCanceling={true}
                                                                labelText='or Drag & Drop the file here'
                                                                onValueChanged={onFileChanged}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='resumeText'>General Contractor's Resume (Text)</label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>
                                                                If you did not upload the resume you may type it instead.
                                                            </span>
                                                        </span>
                                                        <textarea
                                                            id='resumeText'
                                                            value={resumeText}
                                                            onChange={(e) => set_resumeText(e.target.value)}
                                                            required={false}
                                                            rows={4}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='modal-content-actions'>
                                                <button
                                                    type='button'
                                                    data-testid='accept-button'
                                                    className='button primary'
                                                    style={{
                                                        width: 150,
                                                    }}
                                                    onClick={cancelGeneralContractor}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    type='button'
                                                    data-testid='accept-button'
                                                    className='button primary'
                                                    style={{
                                                        width: 150,
                                                    }}
                                                    onClick={saveGeneralContractor}
                                                    disabled={!canContinue || !saveEnabled}
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions></DialogActions>
            </Dialog>
        </div>
    );
};
